// extracted by mini-css-extract-plugin
export default {"tooltip":"TermDescriptionHoverTooltip_tooltip__RjupJ"};